/** History can arrive as Unix seconds, milliseconds, or a server date string. */
export function historyTimestamp(value: unknown): number {
  let timestamp =
    typeof value === "number"
      ? value
      : typeof value === "string" && value.trim()
        ? Number.isFinite(Number(value))
          ? Number(value)
          : Date.parse(value)
        : NaN;
  if (!Number.isFinite(timestamp) || timestamp <= 0) return 0;
  // Repair cached entries from the old unconditional seconds-to-ms conversion.
  if (timestamp >= 100_000_000_000_000) timestamp /= 1000;
  if (timestamp < 100_000_000_000) timestamp *= 1000;
  return Number.isFinite(new Date(timestamp).getTime()) ? timestamp : 0;
}
